import {Icon} from 'antd'

const IconFont = Icon.createFromIconfontCN({
    // scriptUrl: '//at.alicdn.com/t/font_1518439_9p3lehnyc7e.js',
    scriptUrl: '//at.alicdn.com/t/font_1518439_aa2az5bn43m.js',
});
IconFont.pre = 'changgui'
export default IconFont